// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1_CT2","cls2":"Unibrow-cls2_buo Unibrow-cls1_CT2"};